import React from 'react';
import { PropTypes } from 'prop-types';
import CardContainer from '../../components/CardContainer';
import ShippingInfo from './ShippingInfo';
import CcInfo from './CcInfo';
import CardExpiredNotification from './CardExpiredNotification';
import WhiteSpace from '../../components/WhiteSpace';

const OrderInfo = ({
  onEditBilling,
  hasPaymentInfo,
  paymentInfo,
  hasShippingInfo,
  shippingInfo,
  onEditShipping,
  onEditCreditCardList,
  cvcNumber = '',
  cardType,
}) => (
  <CardContainer>
    <ShippingInfo
      shippingInfo={hasShippingInfo ? shippingInfo : {}}
      onEditShipping={onEditShipping}
      hasShippingInfo={hasShippingInfo}
    />
    <WhiteSpace />
    {hasPaymentInfo && paymentInfo.isExpired === true ? (
      <div>
        <CardExpiredNotification />
        <CcInfo
          paymentInfo={hasPaymentInfo ? paymentInfo : {}}
          hasShippingInfo={hasShippingInfo}
          onEditBilling={onEditBilling}
          onEditCreditCardList={onEditCreditCardList}
          hasPaymentInfo={hasPaymentInfo}
          cvcNumber={cvcNumber}
          cardType={cardType}
        />
      </div>
    ) : (
      <CcInfo
        paymentInfo={hasPaymentInfo ? paymentInfo : {}}
        hasShippingInfo={hasShippingInfo}
        onEditBilling={onEditBilling}
        onEditCreditCardList={onEditCreditCardList}
        hasPaymentInfo={hasPaymentInfo}
        cvcNumber={cvcNumber}
        cardType={cardType}
      />
    )}
  </CardContainer>
);

OrderInfo.propTypes = {
  onEditShipping: PropTypes.func.isRequired,
  onEditBilling: PropTypes.func.isRequired,
  onEditCreditCardList: PropTypes.func.isRequired,
  hasShippingInfo: PropTypes.bool.isRequired,
  shippingInfo: PropTypes.object,
  hasPaymentInfo: PropTypes.bool.isRequired,
  paymentInfo: PropTypes.object,
  cvcNumber: PropTypes.string,
  cardType: PropTypes.string,
};

export default OrderInfo;



// WEBPACK FOOTER //
// ./src/containers/CartPage/OrderInfo.jsx